import React from 'react';
import { motion } from 'motion/react';
import { Award, ShieldCheck, Leaf, Globe, CheckCircle } from 'lucide-react';

const CERTIFICATIONS = [
  { icon: Leaf, text: "100% Organic Practices" },
  { icon: ShieldCheck, text: "KEBS Certified" },
  { icon: Globe, text: "Export Quality" },
  { icon: CheckCircle, text: "Zero Waste" },
  { icon: Award, text: "Fair Trade" },
];

export const CertificationsMarquee: React.FC = () => {
  return (
    <div className="bg-avo-forest text-white py-4 overflow-hidden flex relative">
      <motion.div
        className="flex space-x-16 whitespace-nowrap items-center"
        animate={{ x: [0, -1000] }}
        transition={{ repeat: Infinity, ease: "linear", duration: 20 }}
      >
        {[...CERTIFICATIONS, ...CERTIFICATIONS, ...CERTIFICATIONS, ...CERTIFICATIONS].map((cert, i) => (
          <div key={i} className="flex items-center gap-2">
            <cert.icon className="text-avo-gold w-5 h-5 md:w-6 md:h-6" />
            <span className="font-heading font-bold tracking-widest uppercase text-xs md:text-sm">{cert.text}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};
